<template>
  <div class="card-container">
    <common-top-form
      ref="formModel"
      :model="formModel"
      :show="!show"
      :forceShow="force"
      forceShowType="warning"
      :buttonName="isPay ? '重发' : '退款'"
      buttonType="warning"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      v-if="!isDetail || isPay"
      :selectShow="!isPay"
      :needCheck="needCheck"
      @check="handleCheck"
      @checks="handleChecks"
      @openAddDialog="isPay ? handleReset() : openAddDialog()"
    >
      <span v-if="!isDetail && !isPay">
        <el-form-item label="交易类型">
          <el-select v-model="formModel.operationType">
            <el-option
              v-for="item in operationTypes"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            v-model="formModel.orderId"
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>
      </span>
    </common-top-form>
    <el-row
      :gutter="20"
      v-if="!show"
      style="margin-bottom: 20px"
      class="flow-wrap showInfoDialog"
    >
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>机构名称：{{ memInfo.tatName }}</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>姓名：{{ memInfo.realName }}</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>手机号：{{ memInfo.phoneNumber }}</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>会员等级：{{ memInfo.levelName }}</p>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <p>账户状态：{{ memInfo.memStatus == 1 ? "启用" : "禁用" }}</p>
      </el-col>
    </el-row>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        prop="userName"
        label="姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="电话号码"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operationType"
        label="交易类型"
        min-width="100"
        :formatter="formatoperationTypes"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="业务类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operationAmt"
        label="金额"
        min-width="150"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="分润时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";

import OrganService from "service/OrganService";
import ChannelService from "service/ChannelService";
import ChannelCashService from "service/ChannelCashService";
import OrganCashService from "service/OrganCashService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import SelectOrgans from "components/business/SelectOrgans";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "RefundManageInner",
  data() {
    return {
      formModel: {
        orderId: "",
        operationType: "",
      },
      submitService: ChannelCashService.tatRefundInfoList,
      tableData: [],
      operationTypes: [],
      info: {},
      memInfo: {},
      needCheck: true,
      force: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
  },
  computed: {
    show() {
      return !this.memInfo.id;
    },
    submitData() {
      const params = {
        userId: this.userId,
        orderId: this.formModel.orderId,
        operationType: this.formModel.operationType,
      };
      return params;
    },
    isDetail() {
      return this.$route.params.flag == 1;
    },
    isPay() {
      return this.$route.params.flag == 3;
    },

    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.getTypeNames("退款交易类型", (res) => {
      this.operationTypes = res;
      this.formModel.operationType = this.operationTypes[0]
        ? this.operationTypes[0].dictKey
        : "";
    });
    if (this.isDetail || this.isPay) {
      this.info = JSON.parse(this.$route.params.info);
      this.getList();
    }
  },
  methods: {
    handleCheck() {
      if (!this.formModel.orderId || !this.formModel.operationType) {
        this.showWarming("请补全筛选条件");
        return;
      }
      this.needCheck = false;

      this.$refs.formModel.submit();
    },
    // 强制退款
    handleChecks() {
      this.doLoad(
        ChannelCashService.tatRefundInfoForceRefund,
        {
          orderId: this.formModel.orderId,
          operationType: this.formModel.operationType,
          tatSimpleId: this.memInfo.tatId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.respMsg);
            this.$refs.formModel.submit();
          });
        },
        "信息获取失败"
      );
    },
    getList() {
      const params = this.isPay
        ? {
            orderId: this.info.orgOrderNo,
            userId: this.userId,
            operationType: 1,
          }
        : {
            orderId: this.info.orderId,
            tatSimpleId: this.info.tatSimpleId,
          };
      this.doLoad(
        this.isPay ? this.submitService : ChannelCashService.getInfoByOrderId,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            if (this.isPay) {
              this.onSuccess(res);
              return;
            }
            this.tableData = result;
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog() {
      this.doLoad(
        ChannelCashService.tatRefundInfoRefund,
        {
          orderId: this.formModel.orderId,
          operationType: this.formModel.operationType,
          tatSimpleId: this.memInfo.tatId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.respMsg);
            this.$refs.formModel.submit();
          });
        },
        "信息获取失败"
      );
    },
    handleReset() {
      this.doLoad(
        ChannelCashService.updatePaySt,
        {
          orgOrderNo: this.info.orgOrderNo,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.respMsg);
            this.$router.go(-1);
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.list;
        this.memInfo = result.memInfo;
        if (this.$route.params.flag == 3) {
          this.force = false;
        } else {
          this.force = true;
        }
      });
    },
    formatoperationTypes(row, column, cellValue, index) {
      let value = "--";
      this.operationTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/RefundManageInner.vue